import { Pipe, PipeTransform } from "@angular/core";
import { ProgramacionService } from '../../infraestructure/programacion/programacion-api.service';

@Pipe({
    name: 'profesional',
    standalone: false
})
export class ProfesionalPipe implements PipeTransform {

  result: string = '';

  constructor(private programacionService: ProgramacionService) {}
    transform(value) {

         if(value){
          return this.programacionService.consultarProfesionalPorDocumento(value).then( value =>value);
        }
      }
}
